import React, { useEffect, useState, useContext } from 'react';
import { Grid, Box, Button } from "@material-ui/core";
import useStyles from "../../../themes/makeStyles";
import clsx from "clsx";
import { useForm, Controller } from "react-hook-form";
import moment from "moment";
import FormValidationErrorMessage from "../../../components/FormValidationErrorMessage";
import DateRangePicker from "../../../components/DateRangePicker";
import Autocomplete from "../../../components/AutoComplete";
import { default as ApiServices } from "../../../common";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import { default as Apiservices } from '../../../common';
import GlobalContext from "../../../common/contexts/GlobalContext";

export default function FilterForm(props) {
    const classes = useStyles();
    const [sftorrStartDate, setSftorrStartDate] = useState('');
    const [sftorrEndDate, setSftorrEndDate] = useState('');
    const [unloadingStartDate, setUnloadingStartDate] = useState('');
    const [unloadingEndDate, setUnloadingEndDate] = useState('');
    const defaultValues = {
        rake_name: '',
        origin: '',
        destination: '',
        rr_start_end_date: [],
        unloading_date: '',
    }
    const methods = useForm({
        mode: "onChange",
        validateCriteriaMode: "all",
        submitFocusError: true,
        defaultValues,
    });

    const [rakelistDropdownOpt, setRakelistDropdownOpt] = React.useState([]);
    const [originListOptions, setOriginListOptions] = React.useState([]);
    const [destinationListOptions, setDestinationListOptions] = React.useState([]);
    const [disableDownloadButton, setDisableDownloadButton] = React.useState(true);
    const [resetvalues, setResetvalues] = React.useState(true);
    const {
        control, errors, handleSubmit, reset
    } = methods;

    const setMasterDropdownOptions = async () => {

        let listSftoActiveRakes = [];
        const listSftoRakes = await Apiservices.listSftoActiveRakes()
        listSftoRakes.map((rakeSftoObj) => {
            let listSftoRakeObj = {};
            listSftoRakeObj.value = rakeSftoObj.rake_id;
            listSftoRakeObj.label = rakeSftoObj.rake_name;
            listSftoActiveRakes.push(listSftoRakeObj);
        });
        setRakelistDropdownOpt(listSftoActiveRakes);

        const listOriginDetails = await Apiservices.getoriginslist({ schemetype: 'SFTO' });
        //console.log(listOriginDetails);
        const listDestinationDetails = await Apiservices.getdestinationslist({ schemetype: 'SFTO' });
        //console.log(listDestinationDetails);
        let originStations = [];
        let destinationStations = [];
        listOriginDetails[0].map((odObj) => {
            let originObj = {};
            originObj.value = odObj.origin_station_code;
            originObj.label = odObj.origin_station_code;
            originStations.push(originObj);
        });
        setOriginListOptions(originStations)
        listDestinationDetails[0].map((odObj) => {
            let destinationObj = {};
            destinationObj.value = odObj.destination_station_code;
            destinationObj.label = odObj.destination_station_code;
            destinationStations.push(destinationObj);
        });
        setDestinationListOptions(destinationStations)

    };



    const onSubmitForm = async (data) => {
        debugger;
        console.log(Object.values(data), Object.values(data).some(val => !(val === null || val === '' || val === undefined)), "values")
        if (Object.values(data) && Object.values(data).length > 0 && Object.values(data).some(val => !(val === null || val === '' || val === undefined))) {
            const body = {
                rake_name: data.rake_name ? data.rake_name.label : null,
                origin: data.origin ? data.origin.value : null,
                destination: data.destination ? data.destination.value : null,
                rr_start_date: sftorrStartDate,
                rr_end_date: sftorrEndDate,
                unloading_start_date: unloadingStartDate,
                unloading_end_date: unloadingEndDate,
            }
            console.log('body comes here', body);
            props.getFilterData(body)
            setDisableDownloadButton(false)
        } else {
            return;
        }

    }

    const generateReport = async () => {
        let data = methods.getValues({ nest: true })
        const body = {
            rake_name: data.rake_name ? data.rake_name.label : null,
            origin: data.origin ? data.origin.value : null,
            destination: data.destination ? data.destination.value : null,
            rr_start_date: sftorrStartDate,
            rr_end_date: sftorrEndDate,
            unloading_start_date: unloadingStartDate,
            unloading_end_date: unloadingEndDate,
        }
        Apiservices.downloadTripWiseProfitabilityReports(body);
    };

    const resetForm = () => {
        setResetvalues(!resetvalues)
        setSftorrStartDate(null);
        setSftorrEndDate(null);
        setUnloadingStartDate(null);
        setUnloadingEndDate(null);
        methods.reset(defaultValues);
        methods.setValue("rr_start_end_date", '');
        methods.setValue("unloading_date", null)
        props.handleClear();
        setDisableDownloadButton(true);
    }

    useEffect(() => {
        const fetchData = async () => {
            await setMasterDropdownOptions()
        };
        fetchData();
    }, []);


    return (
        <>
            <form noValidate id="filter-form" onSubmit={handleSubmit(onSubmitForm)} key={resetvalues} >
                <Grid container spacing={2}>
                    <Grid item container spacing={2}>

                        <Grid item xs={12} sm={3}>
                            <Autocomplete
                                name="rake_name"
                                id="rake_name"
                                control={control}
                                Values={rakelistDropdownOpt}
                                rules={{ required: false }}
                                required={false}
                                label="Rake Name"
                                error={errors.rake_name}
                            />
                            {errors.rake_name && (
                                <FormValidationErrorMessage
                                    errors={errors}
                                    errorMessagePrefix="Rake Name"
                                    name="rake_name"
                                />
                            )}
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <Autocomplete
                                name="origin"
                                id="origin"
                                control={control}
                                Values={originListOptions}
                                disabled={false}
                                rules={{ required: false }}
                                getValueChanged={(data) => {
                                    // handleCustomerRefChange(data)
                                }}
                                required={false}
                                label="Origin"
                                error={errors.origin}
                            />
                            {errors.origin && (
                                <FormValidationErrorMessage
                                    errors={errors}
                                    errorMessagePrefix="Origin"
                                    name="origin"
                                />
                            )}
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <Autocomplete
                                name="destination"
                                id="destination"
                                control={control}
                                Values={destinationListOptions}
                                disabled={false}
                                rules={{ required: false }}
                                getValueChanged={(data) => {
                                    // handleCustomerRefChange(data)
                                }}
                                required={false}
                                label="Destination"
                                error={errors.destination}
                            />
                            {errors.destination && (
                                <FormValidationErrorMessage
                                    errors={errors}
                                    errorMessagePrefix="Destination"
                                    name="destination"
                                />
                            )}
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <Controller
                                as={<DateRangePicker />}
                                name="rr_start_end_date"
                                id="rr_start_end_date"
                                control={control}
                                rules={{ required: false }}
                                required={false}
                                disabled={false}
                                onChange={([value]) => {
                                    console.log(value, "date")
                                    let queryparams = {};
                                    let rr_start_end_dates = value.split("To");
                                    setSftorrStartDate(rr_start_end_dates
                                        ? moment(rr_start_end_dates[0].trim(), "DD-MM-YYYY").format("YYYY-MM-DD")
                                        : null);
                                    setSftorrEndDate(
                                        rr_start_end_dates
                                            ? moment(rr_start_end_dates[1].trim(), "DD-MM-YYYY").format("YYYY-MM-DD")
                                            : null
                                    );
                                    return value;
                                }}
                                label="RR Date Range"
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <Controller
                                as={<DateRangePicker />}
                                name="unloading_date"
                                id="unloading_date"
                                control={control}
                                rules={{ required: false }}
                                required={false}
                                disabled={false}
                                onChange={([value]) => {
                                    console.log(value, "date")
                                    let queryparams = {};
                                    let rr_start_end_dates = value.split("To");
                                    setUnloadingStartDate(rr_start_end_dates
                                        ? moment(rr_start_end_dates[0].trim(), "DD-MM-YYYY").format("YYYY-MM-DD")
                                        : null);
                                    setUnloadingEndDate(
                                        rr_start_end_dates
                                            ? moment(rr_start_end_dates[1].trim(), "DD-MM-YYYY").format("YYYY-MM-DD")
                                            : null
                                    );
                                    return value;
                                }}
                                label="Unloading Date Range"
                            />
                        </Grid>
                        {/* 
                        <Grid item xs={12} sm={3}>
                            <Autocomplete
                                name="service_type"
                                control={control}
                                Values={schemeTypeVal == 'SFTO' ? service_type : service_type_gpwis}
                                disabled={false}
                                // defaultValue={frequency[1]}
                                getValueChanged={(data) => {
                                    // handleYearChange(data, true);
                                }}
                                label="Service Type"
                            />
                        </Grid> */}
                    </Grid>
                </Grid>

                <Box py={2}>
                    <Grid container direction="row" justify="space-between">
                        <Grid item>
                        </Grid>
                        <Grid item>
                            <Grid container spacing={1} justify="flex-end">
                                <Grid item>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        className={clsx(
                                            classes.subTextButton
                                        )}
                                        type="button"
                                        onClick={generateReport}
                                        startIcon={<CloudDownloadIcon />}
                                        disabled={disableDownloadButton}
                                    >
                                        Export to Excel
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        id="SearchIcon"
                                        className={classes.subTextButton}
                                        type="submit"
                                    // onClick={handleFilterSearch}
                                    >
                                        Submit
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button
                                        variant="outlined"
                                        disabled={false}
                                        className={clsx(
                                            classes.subTextButton,
                                            "btnMinWidthSearch"
                                        )}
                                        onClick={resetForm}
                                    >
                                        Clear
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </form>
        </>
    );
}